import clsx from "clsx";
import styles from "./detections.module.scss";

type Props = {
  className?: string;
  matches: number | string;
  onClick?: () => void;
};

const YaraDetections = ({ className, matches, onClick }: Props) => (
  <div
    data-testid="report_summary_yara_detections_container"
    className={clsx(styles.detections_section, className)}
    onClick={onClick}
  >
    <span className={styles.detections_section_title}>YARA Matches</span>
    <div className="text-center">
      <span
        className={styles.detections_yara_matches}
        data-testid="report_summary_yara_detections_matches_count"
      >
        {matches}
      </span>
    </div>
  </div>
);

export default YaraDetections;
